import { useQuery } from "@tanstack/react-query";

import { useUserToken } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { authHeader } from "@/utils/headers";
import { WorkflowVersion } from "@/components/Workflows/types";
import { ENDPOINTS } from "@/api/application-api";

interface GetWorkflowRequest {
  workspace_id: number;
  workflow_name: string;
  label?: string | null;
  number?: number | null;
}

const useWorkflowVersion = ({
  workflowName,
  label,
  number,
}: {
  workflowName?: string;
  label?: string | null;
  number?: number | null;
}) => {
  const workspaceId = useUser()?.activeWorkspaceId ?? 0;
  const userToken = useUserToken();

  return useQuery<WorkflowVersion>({
    queryKey: ["workflow-version-v2", workspaceId, workflowName, label, number],
    queryFn: async () => {
      const body: GetWorkflowRequest = {
        workspace_id: workspaceId,
        workflow_name: workflowName ?? "",
        label: label ?? undefined,
        number: number ?? undefined,
      };

      const response = await fetch(ENDPOINTS.get_workflow, {
        method: "POST",
        headers: {
          ...authHeader(userToken),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch workflow version");
      }

      const data = await response.json();
      return data;
    },
    enabled: !!workspaceId && !!workflowName,
  });
};

export default useWorkflowVersion;
